import { API } from './API';

const DEFAULT_OPTIONS = {
  baseUrl: 'sensors',
};

export class SensorsAPI extends API {
  constructor(options = {}) {
    super({ ...DEFAULT_OPTIONS, ...options });
  }

  get(orgId, personId, sensorId) {
    const params = [orgId, sensorId];
    const query = { personId };
    return super.get({ params, query });
  }

  list(orgId, personId, meta = {}) {
    const { page, page_size } = meta;

    const params = [orgId];
    const query = { personId, page, limit: page_size };
    return super.get({ params, query });
  }

  update(orgId, personId, sensorId, data = {}) {
    const params = [orgId, sensorId];
    const query = { personId };
    return super.put({ params, query }, data);
  }

  create(orgId, personId, data = {}) {
    const params = [orgId];
    const query = { personId };
    return super.post({ params, query }, data);
  }

  delete(orgId, personId, sensorId) {
    const params = [orgId, sensorId];
    const query = { personId };
    return super.delete({ params, query });
  }

  createModule(orgId, personId, sensorId, data = {}) {
    const params = [orgId, sensorId, 'module'];
    const query = { personId };
    return super.post({ params, query }, data);
  }

  updateModule(orgId, personId, sensorId, sensorModuleUUID, data = {}) {
    const params = [orgId, sensorId, 'module', sensorModuleUUID];
    const query = { personId };
    return super.put({ params, query }, data);
  }

  deleteModule(orgId, personId, sensorId, sensorModuleUUID) {
    const params = [orgId, sensorId, 'module', sensorModuleUUID];
    const query = { personId };
    return super.delete({ params, query });
  }
}



// WEBPACK FOOTER //
// ./src/lib/api/SensorsAPI.js